import { createFeatureSelector, createSelector } from '@ngrx/store';


import { AppState } from '../../../reducers/index';
import * as fromUploadableFormAttachmentReducer from './uploadable-form-attachment.reducer';

export const currentState = (state: AppState) => (state[fromUploadableFormAttachmentReducer.uploadableFormAttachmentsFeatureKey]);

export const selectAllUploadableFormAttachment = createSelector(currentState, fromUploadableFormAttachmentReducer.selectAll);

export const selectTotalUploadableFormAttachment = createSelector(currentState, fromUploadableFormAttachmentReducer.selectTotal);

export const selectModifiedUploadableFormAttachments = createSelector(selectAllUploadableFormAttachment, (serviceForms) => {
  return serviceForms.map((serviceForm) => {
    return {
      ...serviceForm,
      modAttachmentIsMandatory: serviceForm.attachmentIsMandatory ? "Yes" : "No"
    };
  });
});

export const selectModifiedUploadableFormAttachmentByUid= (uniqueId) => createSelector(selectAllUploadableFormAttachment, (uploadableForms) =>
uploadableForms.find((uploadableForm) => uploadableForm.attachmentUniqueId === uniqueId));
